import { assign } from "../../helper.js";
import { isBoolean, isNil, isNumber, isString } from "es-toolkit";
//#region ../erd-editor-schema/dist/v2/parser/memo.js
var createMemoEntity = () => ({ memos: [] });
var createMemo = () => ({
	id: "",
	value: "",
	ui: {
		active: false,
		left: 200,
		top: 200,
		zIndex: 2,
		width: 127,
		height: 127
	}
});
function createAndMergeMemoEntity(json) {
	const entity = createMemoEntity();
	if (isNil(json) || !Array.isArray(json.memos)) return entity;
	for (const memo of json.memos) {
		const target = createMemo();
		const assignString = assign(isString, target, memo);
		const uiAssignNumber = assign(isNumber, target.ui, memo.ui);
		const uiAssignBoolean = assign(isBoolean, target.ui, memo.ui);
		const uiAssignString = assign(isString, target.ui, memo.ui);
		assignString("id");
		assignString("value");
		uiAssignBoolean("active");
		uiAssignString("color");
		uiAssignNumber("left");
		uiAssignNumber("top");
		uiAssignNumber("zIndex");
		uiAssignNumber("width");
		uiAssignNumber("height");
		entity.memos.push(target);
	}
	return entity;
}
//#endregion
export { createAndMergeMemoEntity };
